import classNames from "classnames"
import { Modal } from "common/Modal"
import { useNotifications } from "hooks/useNotification"
import { useState } from "react"
import UserService from "services/user.service"
import { PackageList, PositionList, SeasonList, States } from "utils/constants"

const service = new UserService()

export const EditMediaAd = ({
  showModal,
  selected,
  fetchData,
  setSelected,
  setShowModal,
}) => {
  const [state, setState] = useState({
    notes: "",
    ad_spend: "",
  })
  const [submitting, setSubmitting] = useState(false)
  const [selectedPackage, setSelectedPackage] = useState(0)

  const { successMessage } = useNotifications()

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    service
      .updateMediaAd(selected.id, {
        ad_status: selected.ad_status,
        ad_approval_status: selected.ad_approval_status,
        ad_type: selected.ad_type,
        state: selected.state,
        season: selected.season,
        ad_amount: selected.ad_amount,
        position: selected.position,
        meet_link: selected.meet_link,
        package_start_date: selected.package_start_date,
        package_end_date: selected.package_end_date,
        city_name: selected.city_name,
        ...state,
      })
      .then(() => {
        fetchData()
        successMessage("Successfully updated")
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setSubmitting(false)
        setShowModal(false)
      })
  }

  const calculateNewDate = (days, date) => {
      const updatedDate = new Date(date);
      updatedDate.setDate(updatedDate.getDate() + days);
      return updatedDate
  };

  const onChangePackage = (days, packageName, amount) => {
    setSelectedPackage(days)
    setSelected({ 
      ...selected,
      package_start_date: selected.package_start_date,
      package_end_date: calculateNewDate(days, selected.package_start_date),
      package_name: packageName,
      ad_amount: amount,
    })
  }

  const handleChangeStart = (date) => {
    const currentDays = selected?.package_name === "PREMIUM" ? 5 : selected?.package_name === "BASIC" ? 3 : 4
    setSelected({
      ...selected,
      package_start_date: date,
      package_end_date: calculateNewDate(currentDays, date),
    })
  }

  return (
    <Modal
      width="w-full md:w-1/2"
      showModal={showModal}
      setShowModal={setShowModal}
      title="Update Media Ad"
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <div className="flex gap-3">
          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">Approval Status</label>
            <select
              onChange={(e) =>
                setSelected({
                  ...selected,
                  ad_approval_status: e.target.value,
                })
              }
              value={selected.ad_approval_status}
              className="w-full px-3 py-2 text-sm"
            >
              <option value="All">All</option>
              <option value="UNDER REVIEW">UNDER REVIEW</option>
              <option value="DENIED">DENIED</option>
              <option value="APPROVED">APPROVED</option>
            </select>
          </div>
          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">Ad Status</label>
            <select
              onChange={(e) =>
                setSelected({
                  ...selected,
                  ad_status: e.target.value,
                })
              }
              value={selected.ad_status}
              className="w-full px-3 py-2 text-sm"
            >
              <option value="All">All</option>
              <option value="In Process">In Process</option>
              <option value="Upcoming">Upcoming</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
        </div>
        <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
          <label className="field-label">Ad Spend</label>
          <input
            type="text"
            value={state.ad_spend}
            onChange={(e) => setState({ ...state, ad_spend: e.target.value })}
            placeholder="$0.00"
            className="w-full px-3 py-2 text-sm"
          />
        </div>
        <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
          <label className="field-label">Meet Link</label>
          <input
            type="text"
            value={selected.meet_link}
            onChange={(e) => setSelected({ ...selected, meet_link: e.target.value })}
            placeholder="Link"
            className="w-full px-3 py-2 text-sm"
          />
        </div>
        <div className="flex gap-3">
          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">State</label>
            <select
              onChange={(e) =>
                setSelected({
                  ...selected,
                  state: e.target.value,
                })
              }
              value={selected.state}
              className="w-full px-3 py-2 text-sm"
            >
              <option value="">Select State</option>
              {States.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">City Name</label>
            <input
              type="text"
              value={selected.city_name}
              onChange={(e) =>
                setSelected({ ...selected, city_name: e.target.value })
              }
              placeholder="City Name"
              className="w-full px-3 py-2 text-sm"
            />
          </div>
        </div>
        <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
          <label className="field-label">Ad Type</label>
          <div className="flex gap-3">
            <button className="px-4 py-2 text-white bg-ink hover:bg-gray-800 border border-black rounded-lg">
              RECRUITING
            </button>
            <button
              disabled={true}
              className="px-4 py-2 border border-black rounded-md disabled:cursor-not-allowed "
            >
              SALES LEAD
            </button>
          </div>
        </div>
        <div>
          <h1 className="text-lg font-semibold text-zinc-800">Ad Details</h1>
          <div className="flex gap-3">
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Season</label>
              <select
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    season: e.target.value,
                  })
                }
                value={selected.season}
                className="w-full px-3 py-2 text-sm"
              >
                <option value="">Select Season</option>
                {SeasonList.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Position</label>
              <select
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    position: e.target.value,
                  })
                }
                value={selected.position}
                className="w-full px-3 py-2 text-sm"
              >
                <option value="">Select Position</option>
                {PositionList.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex-1 flex flex-col gap-1.5 mt-2 min-w-[150px]">
            <label className="field-label">Ad Package</label>
            <div className="flex gap-3">
              {PackageList.map((item) => (
                <div key={item.day} onClick={() => onChangePackage(item.day, item.packageName, item.price)} className={classNames("flex-1 text-center border border-black cursor-pointer hover:bg-black hover:text-white flex flex-col  px-4 py-3 rounded-md", {
                  "bg-black text-white": item.packageName === selected.package_name,
                })}>
                  <span className="text-lg font-semibold">${item.price}</span>
                  <span className="">
                    {item.day} Days 
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-3 mt-3">
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">Start Date</label>
              <input 
              type="date"
              value={selected?.package_start_date && new Date(selected.package_start_date)?.toISOString().split('T')[0]}
              onChange={(e) => handleChangeStart(e.target.value)}
              className="w-full px-3 py-2 text-sm"
              />
            </div>
            <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
              <label className="field-label">End Date</label>
              <input 
              type="date"
              disabled={true}
              value={selected?.package_end_date && new Date(selected.package_end_date)?.toISOString().split('T')[0]}
              onChange={(e) => setSelected({ ...selected, package_end_date: e.target.value })}
              className="w-full px-4 py-2 font-light text-gray-800 border-gray-200 rounded-md disabled:bg-gray-100 focus:border-gray-300 focus:outline-none focus:ring-0"
              />
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
          <label className="field-label">Admin Notes</label>
          <textarea
            value={state.notes}
            onChange={(e) => setState({ ...state, notes: e.target.value })}
            rows={4}
            className="w-full px-3 py-2 text-sm"
          />
        </div>

        <button type="submit" className="btn-dark">
          {submitting ? "Updating..." : "Update"}
        </button>
      </form>
    </Modal>
  )
}
